var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "audience" }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "text-xs-center" },
          [
            _c("v-progress-circular", {
              staticClass: "primary--text",
              attrs: { indeterminate: "", size: 100, width: 1 }
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "v-card",
              [
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c("v-flex", { attrs: { xs6: "", sm3: "", md2: "" } }, [
                          _c(
                            "div",
                            { staticClass: "grey--text text--darken-2" },
                            [
                              _vm._v(
                                _vm._s(_vm._f("cap")(_vm.$t("trackedPages")))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "headline teal--text" }, [
                            _vm._v(_vm._s(_vm.nbLoads))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs6: "", sm3: "", md2: "" } }, [
                          _c(
                            "div",
                            { staticClass: "grey--text text--darken-2" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("cap")(
                                    _vm.$tc("visitors", 2, { count: "" })
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "headline blue--text" }, [
                            _vm._v(_vm._s(_vm.nbVisitors))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs6: "", sm3: "", md2: "" } }, [
                          _c(
                            "div",
                            { staticClass: "grey--text text--darken-2" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("cap")(
                                    _vm.$tc("chats", 2, { count: "" })
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "headline pink--text" }, [
                            _vm._v(_vm._s(_vm.nbChats))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs6: "", sm3: "", md2: "" } }, [
                          _c(
                            "div",
                            { staticClass: "grey--text text--darken-2" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("cap")(_vm.$t("conversationRate"))
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "headline primary--text" }, [
                            _vm._v(_vm._s(_vm.conversation) + " %")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("v-flex", { attrs: { xs6: "", sm3: "", md2: "" } }, [
                          _c(
                            "div",
                            { staticClass: "grey--text text--darken-2" },
                            [_vm._v("AI CSAT")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "headline amber--text text--darken-3"
                            },
                            [_vm._v(_vm._s(_vm.averageCsat) + " /100")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm6: "", md2: "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                label: _vm._f("cap")(_vm.$t("dataInterval")),
                                items: _vm.intervals,
                                "return-object": ""
                              },
                              model: {
                                value: _vm.interval,
                                callback: function($$v) {
                                  _vm.interval = $$v
                                },
                                expression: "interval"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", sm6: "", md2: "" } },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "primary", dark: "", flat: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.download()
                                  }
                                }
                              },
                              [
                                _vm._v(_vm._s(_vm.$t("exportInCsv"))),
                                _c(
                                  "v-icon",
                                  { attrs: { color: "primary", right: "" } },
                                  [_vm._v("file_download")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("highcharts", { attrs: { options: _vm.options } })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a2cd4b8", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a2cd4b8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/Audience.vue
// module id = null
// module chunks = 